import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const currencyRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('currencies', {
      list: () => import(/* webpackChunkName: "payments" */ './Pages/List.vue'),
    })
      .except(['create', 'edit'])
      .permissions({
        list: 'currencies.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
